import { c as _c } from "react/compiler-runtime";
import classNames from 'classnames';
import { type HTMLAttributes, type ReactNode } from 'react';
import styles from './ButtonGroup.module.scss';
export type ButtonGroupAlign = 'start' | 'center' | 'end';
export type ButtonGroupMobileLayout = 'stack' | 'wrap';
export interface ButtonGroupProps extends HTMLAttributes<HTMLDivElement> {
  align?: ButtonGroupAlign;
  mobileLayout?: ButtonGroupMobileLayout;
  children: ReactNode;
}
function ButtonGroup(t0) {
  const $ = _c(14);
  let children;
  let className;
  let props;
  let t1;
  let t2;
  if ($[0] !== t0) {
    ({
      align: t1,
      mobileLayout: t2,
      className,
      children,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = props;
    $[4] = t1;
    $[5] = t2;
  } else {
    children = $[1];
    className = $[2];
    props = $[3];
    t1 = $[4];
    t2 = $[5];
  }
  const align = t1 === undefined ? "start" : t1;
  const mobileLayout = t2 === undefined ? "stack" : t2;
  const t3 = styles[`helios-button-group--align-${align}`];
  const t4 = styles[`helios-button-group--mobile-${mobileLayout}`];
  let t5;
  if ($[6] !== className || $[7] !== t3 || $[8] !== t4) {
    t5 = classNames(styles["helios-button-group"], t3, t4, className);
    $[6] = className;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== children || $[11] !== props || $[12] !== t5) {
    t6 = <div className={t5} {...props}>{children}</div>;
    $[10] = children;
    $[11] = props;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  return t6;
}
export default ButtonGroup;